/**
 * ErrorPage
 *
 * We show this page when an uncaught exception occurs
 *
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { withStyles } from 'tss-react/mui';

import planeCrashed from 'assets/illustrations/Plane-Crash.png';
import ReportProblemLink from 'components/ReportProblemLink';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 800,
    flexGrow: 1,
    margin: '46px auto 0 auto',
    padding: 40,
  },
  buttonRoot: {
    maxHeight: '32px !important',
    marginBottom: 20,
  },
});

const Heading = styled.h1`
  font-size: 34px;
  color: #2675b8;
  font-weight: 200;
  margin: 0;
`;

const Subheading = styled.h2`
  font-size: 18px;
  color: #666;
  font-weight: 400;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

class ErrorPage extends PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    classes: PropTypes.object,
  };
  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <Heading>Uh Oh. Something isn&rsquo;t quite right here.</Heading>
        <Subheading>
          Our mistake! Rest assured, we&rsquo;re working to resolve the problem as soon as possible.
          <br />
          We apologize for the inconvenience.
        </Subheading>
        <Link to='/' style={{ textDecoration: 'none' }}>
          <Button variant='contained' color='primary' className={classes.buttonRoot}>
            RETURN TO DASHBOARD
          </Button>
        </Link>

        <ReportProblemLink feedbackSubject='report js crash' />

        <img alt='electrical cord unplugged' src={planeCrashed} role='presentation' style={{ maxWidth: 168 }} />
      </Paper>
    );
  }
}

export default withStyles(ErrorPage, styles);
